import { render, staticRenderFns } from "./DlgManageCBCCustomize.vue?vue&type=template&id=5f01f642&scoped=true"
import script from "./DlgManageCBCCustomize.vue?vue&type=script&lang=js"
export * from "./DlgManageCBCCustomize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f01f642",
  null
  
)

export default component.exports